import HomePage from 'company-app/home';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Provider } from 'react-redux';
import 'react-toastify/dist/ReactToastify.css';

import companyStore from 'company-app/redux/company.store';
import { companyStoreContext } from 'company-app/redux/company.store';

function CompanyApp() {
  return (
    <Provider store={companyStore} context={companyStoreContext}>
      <HomePage />
    </Provider>
  );
}

export default CompanyApp;
